import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './app/providers';
import { AppRouter } from './app/router';
import { BootGate } from './app/boot-gate';
import { installNoZoom } from './lib/no-zoom';
import './styles/globals.css';

installNoZoom();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Elemento #root não encontrado');

createRoot(rootElement).render(
  <StrictMode>
    <Providers>
      <BootGate>
        <AppRouter />
      </BootGate>
    </Providers>
  </StrictMode>,
);
